import { useBunja } from 'bunja/react';
import cx from 'classnames';
import { useAtomValue } from 'jotai';
import { useTranslations } from 'next-intl';

import { css } from '@flipster/styled-system/css';
import { UsdtPrecision } from '@flipster/utils/constants/currency';
import { numberFormatter } from '@flipster/utils/num';

import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';

import { spotFormBunja } from './bunja/form';
import { col, price, priceCol, row } from './styles';

const OrderTypeInfo = () => {
  const transTrade = useTranslations('Trade.r250401');

  const { symbolInfoAtom } = useBunja(tradeSymbolBunja);
  const { availableUsdtAtom, availableBaseCurrencyAtom, sideAtom } = useBunja(spotFormBunja);

  const side = useAtomValue(sideAtom);
  const symbolInfo = useAtomValue(symbolInfoAtom);
  const availableUsdt = useAtomValue(availableUsdtAtom);
  const availableBaseCurrency = useAtomValue(availableBaseCurrencyAtom);

  return (
    <div className={css({ textStyle: 'Text/M/Regular', p: '16px 0' })}>
      <div className={row}>
        <div className={col}>
          <p>{transTrade('Available_usdt')}</p>
        </div>
        <div className={cx(col, priceCol)}>
          <span className={price}>
            {numberFormatter(availableUsdt, {
              toFixed: true,
              precision: UsdtPrecision,
            })}
          </span>
          {symbolInfo?.quoteCurrency}
        </div>
      </div>
      <div className={row}>
        <div className={col}>
          <p>
            {side === 'Buy'
              ? transTrade('Purchasable_symbol', { symbol: symbolInfo?.baseCurrency })
              : transTrade('Sellable_symbol', { symbol: symbolInfo?.baseCurrency })}
          </p>
        </div>
        <div className={cx(col, priceCol)}>
          <span className={price}>
            {numberFormatter(availableBaseCurrency, {
              toFixed: true,
              precision: symbolInfo?.tradeQtyPrecision,
            })}
          </span>
          {symbolInfo?.baseCurrency}
        </div>
      </div>
    </div>
  );
};

export default OrderTypeInfo;
